import React, { useState, useEffect } from 'react';
import { getSaleEndMs } from '../lib/sale';

// Live countdown shown under the price of sale products. Updates every second, rendered in red.
export const SaleCountdown = ({ saleEndDate, language, className = '' }) => {
  const target = getSaleEndMs(saleEndDate);
  const [remaining, setRemaining] = useState(target ? target - Date.now() : 0);

  useEffect(() => {
    if (!target) return undefined;
    setRemaining(target - Date.now());
    const id = setInterval(() => setRemaining(target - Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target || remaining <= 0) return null;

  const totalSec = Math.floor(remaining / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const mins = Math.floor((totalSec % 3600) / 60);
  const secs = totalSec % 60;
  const pad = (n) => String(n).padStart(2, '0');
  const label = language === 'hu' ? 'Akció vége' : 'Sale ends';
  const dayLabel = language === 'hu' ? 'nap' : 'd';

  return (
    <div className={`text-xs font-semibold text-red-500 ${className}`} data-testid="sale-countdown">
      {label}: {days > 0 ? `${days} ${dayLabel} ` : ''}{pad(hours)}:{pad(mins)}:{pad(secs)}
    </div>
  );
};

export default SaleCountdown;
